/**
 * Centralized utility for accessing authentication and user session storage.
 * Prevents raw localStorage access and magic string duplication across services.
 */
export class AuthStorage {
    static getUserId() {
        return localStorage.getItem("EAHSUserID") || "";
    }

    static getSubAccountId() {
        return localStorage.getItem("currentSubAccountId") || "";
    }

    static getInitialOwnerId() {
        return AuthStorage.getSubAccountId() || AuthStorage.getUserId();
    }

    static getUserProfile() {
        try {
            return JSON.parse(localStorage.getItem("eahsUserProfile") || "{}");
        } catch {
            return {};
        }
    }

    static canParticipateWithoutPayment() {
        return AuthStorage.getUserProfile()?.participateWithoutPayment === true;
    }
}
